import { Dispatch, SetStateAction } from 'react';
import { Button } from '../../ui/button';
import { Link } from '@/components/ui/link';

const HumanHandover = ({
	setHumanHandover,
	humanHandoverUrl = '',
}: {
	setHumanHandover: Dispatch<SetStateAction<boolean>>;
	humanHandoverUrl?: string;
}) => {
	return (
		<div className='wlcb-flex wlcb-items-center wlcb-justify-between wlcb-gap-x-space-050'>
			<Link
				className='wlcb-flex-1 !wlcb-justify-start'
				variant='primary'
				name='Yes'
				size='lg'
				href={humanHandoverUrl}
				openInNewWindow={true}
				tabIndex={0}
			/>
			<Button
				className='wlcb-flex-1 !wlcb-justify-start'
				variant='secondary'
				name='No'
				size='lg'
				onClick={() => setHumanHandover(false)}
			/>
		</div>
	);
};

export default HumanHandover;
